<style scoped>
    .container {}

    .left,
    .right {
        width: 100%;
    }
</style>
<template>
    <div class="container">
        <div class="left">
            <Select v-model="selected" transfer @on-change="onChange" size="small">
                <Option v-for="item in options" :key="item.value" :value="item.value">{{item.label}}</Option>
            </Select>
        </div>
        <div class="right">
            url 地址：(会覆盖下拉选择的结果)
            <Input v-model="text" type="text" @on-change="onChange"></Input>
        </div>
    </div>
</template>
<script>
    export default {
        props: ["value"],
        data() {
            // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow'
            return {
                options: [{
                        value: 'circle',
                        label: 'circle'
                    },
                    {
                        value: 'rect',
                        label: 'rect'
                    },
                    {
                        value: 'roundRect',
                        label: 'roundRect'
                    }, {
                        value: 'triangle',
                        label: 'triangle'
                    }, {
                        value: 'diamond',
                        label: 'diamond'
                    },
                    {
                        value: 'pin',
                        label: 'pin'
                    },
                    {
                        value: 'arrow',
                        label: 'arrow'
                    }
                ],
                selected: "",
                text: "",
                timer: null
            }
        },
        watch: {
            value: {
                handler(value) {
                   
                    const result = this.options.find((item) => {
                        return item.value == value;
                    });
                    if (result) {
                        this.selected = value;
                    } else {
                        this.selected = "";
                        this.text = value || "";
                    }
                },
                immediate: true
            }
        },
        methods: {

            onChange() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    const text = this.text.trim();
                    if (text !== "") {
                        this.$emit("input", text)
                        this.$emit('save')
                    } else {
                        this.$emit("input", this.selected)
                        this.$emit('save')
                    }

                }, 1000);

            }
        }
    }
</script>